export const CATEGORY_PLACEMENTS = { indexLarge: 2, indexMosaic: 4, menuFeatured: 4 } as const
